var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3086 0.0078125C17.4789 0.168429 20 2.78979 20 6V14L19.9922 14.3086C19.8368 17.3767 17.3767 19.8368 14.3086 19.9922L14 20H6L5.69141 19.9922C2.62332 19.8368 0.163251 17.3767 0.0078125 14.3086L0 14V6C1.24831e-07 2.78979 2.52111 0.168429 5.69141 0.0078125L6 0H14L14.3086 0.0078125ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6V14C1.5 16.4853 3.51472 18.5 6 18.5H14C16.4853 18.5 18.5 16.4853 18.5 14V6C18.5 3.51472 16.4853 1.5 14 1.5H6ZM10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5ZM10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5ZM15.75 4C16.1642 4 16.5 4.33579 16.5 4.75C16.5 5.16421 16.1642 5.5 15.75 5.5C15.3358 5.5 15 5.16421 15 4.75C15 4.33579 15.3358 4 15.75 4Z",
    fill: "#92B6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9f58b733292afde3bb7573391c557865.svg";
export { ForwardRef as ReactComponent };